export default __webpack_public_path__ + "static/115-9377d118611f1dae53875389da238a82.jpg";